var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyllabus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66251 13.3842C3.82834 13.35 3.99751 13.3333 4.16667 13.3333H5.00001V0.0833333C3.06001 0.479167 1.66667 2.18667 1.66667 4.16667V14.1875C2.24917 13.7483 2.93751 13.4708 3.66251 13.3842ZM18.3333 15H4.16667C2.78584 15 1.66667 16.1192 1.66667 17.5C1.66667 18.8808 2.78584 20 4.16667 20H14.1667C16.4675 20 18.3333 18.1342 18.3333 15.8333V15ZM18.3333 4.16667V13.3333H6.66667V0H10.8333V8.62333C10.8333 9.1425 11.4925 9.365 11.8075 8.9525L12.9167 7.5L14.0258 8.9525C14.3408 9.365 15 9.1425 15 8.62333V0.0841667C16.9017 0.47 18.3333 2.15083 18.3333 4.16667Z",
    fill: "url(#paint0_linear_188_241)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_188_241",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyllabus);
export default __webpack_public_path__ + "static/media/syllabus.442d59515a332811bb5778b0e5519d18.svg";
export { ForwardRef as ReactComponent };